import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';

const Card = styled.div`
  background: #2d3436;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  border: 1px solid #3d4346;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(116, 185, 255, 0.2);
  }
`;

const Image = styled.div`
  width: 100%;
  height: 200px;
  background-color: #3d4346;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;

    &:hover {
      transform: scale(1.05);
    }
  }
`;

const Content = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h3`
  margin: 0 0 0.5rem 0;
  color: #dfe6e9;
`;

const Subtitle = styled.p`
  margin: 0 0 1rem 0;
  color: #b2bec3;
  font-size: 0.9rem;
`;

const Button = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background-color: #74b9ff;
  color: #2d3436;
  margin-top: auto;
  width: 100%;

  &:hover {
    background-color: #0984e3;
  }
`;

interface GameCardProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  itchUrl: string;
  contributors: string[];
  longDescription: string;
  sourceUrl?: string;
}

const GameCard: React.FC<GameCardProps> = ({ 
  title, 
  subtitle, 
  imageUrl, 
  itchUrl, 
  contributors,
  longDescription,
  sourceUrl 
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSeeMore = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Card>
        <Image>
          <img src={imageUrl} alt={title} />
        </Image>
        <Content>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
          <Button onClick={handleSeeMore}>See More</Button>
        </Content>
      </Card>
      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        game={{
          title,
          subtitle,
          imageUrl,
          itchUrl,
          contributors,
          longDescription,
          sourceUrl
        }}
      />
    </>
  );
};

export default GameCard; 